<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-align: center; margin-top: 180px;"><strong>“Ollie, is your mum still sleeping?”</strong></p>
<p style="text-align: center;"><strong>“I don’t know, Dr Kline … It’s wrong, isn’t it?”</strong></p><br/>
<p style="text-align: center;"><strong>And a little later, a young boy was crying.</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?57292414